import { z } from 'zod';

export const CourseStatusSchema = z.enum([
  'DRAFT',
  'PUBLISHED',
  'INACTIVE',
  'PENDING_SUPERSESSION',
  'SUPERSEDED',
  'CLOSED',
]);

export type CourseStatus = z.infer<typeof CourseStatusSchema>;
